import { CommonColDef } from '../../../../../shared/datacenter/column-defs';
import { ColDefWithFields } from '../../../../../shared/datacenter/column-type';

import { ItemQuantityComponent } from './item-quantity.component';

export class ItemQuantityColDef<TData = unknown, TValue = unknown> extends CommonColDef<TData, TValue> {
	constructor(params: ColDefWithFields<TData, TValue>) {
		super({
			cellRenderer: ItemQuantityComponent,
			suppressSizeToFit: true,
			...params
		});
	}
}
